import {
  Box,
  Typography,
  Alert,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import OtherRadio from "../../components/Radio/OtherRadio";
import Label from "../../components/register/Label";
import RegisterModal from "../../components/Modal/RegisterModal";
import AlertDialog from "../../components/register/Modal";
import AuthLayout from "../../components/layouts/AuthLayout";
import { useRouter } from "next/router";


const index = () => {
  const [value, setValue] = useState("");
  const [show, setShow] = useState(true);
  const [open, setOpen] = React.useState(false);


  const pageStyles = {};
  const handleChange = (event) => {
    setValue(event.target.value);
    localStorage.setItem("userType", event.target.value);
  };

  useEffect(() => {
    const userType = localStorage.getItem("userType");
    if (userType) {
      setValue(userType);
    }
  }, []);

  const handleShowChange = () => {
    setShow(false);
    openDialog();
  };

  const openDialog = () => setOpen(true);

  const closeModal = () => {
    router.push('/login')
  };

  const router = useRouter()

  return (
    <>
      <Box
        sx={{
          paddingX: {
            xs: "2.5em",
            sm: "4em",
            md: "4em",
          },
        }}
        bgcolor={"white"}
        maxWidth={"30rem"}
        width={"90%"}
        paddingY="2em"
        borderRadius={"16px"}
      >
        {/* <Typography variant="big" component="p">
          Select the type of Donee account you will like to setup.
        </Typography>
        <Alert
          severity="error"
          color={"grey"}
          sx={{
            marginBlock: "1em",
            borderRadius: "8px",
            fontSize: "14px",
            background: "#fafafa",
            color: "#425A70",
          }}
        >
          Once you setup your Donee account you will be unable to change the
          account type.
        </Alert>
        <FormControl sx={{ marginBottom: "2em" }}>
          <RadioGroup name="radio-buttons-group" onChange={handleChange}>
            <FormControlLabel
              sx={{
                paddingY: "1em",
                paddingX: "0.5em",
                marginBlock: "0.4em",
                boxShadow: "0px 0px 1px rgba(66, 90, 112, 0.4)",
                borderRadius: "8px",
                marginInline: "auto",
                alignItems: "flex-start",
                border: value === "organization" && "1px solid",
                borderColor: value === "organization" && "primary.main",
                "& span.MuiRadio-root": {
                  paddingBlock: "4px",
                },
                background: value === "organization" && "#F5F8FF",
              }}
              checked={value === "organization"}
              value="organization"
              control={<OtherRadio />}
              label={
                <Label
                  padding
                  head={"Registered charity"}
                  body={
                    "Select this option if you are setting up an account for a legally recognised charity organisation."
                  }
                />
              }
            />
            <FormControlLabel
              sx={{
                paddingY: "1em",
                paddingX: "0.5em",
                marginBlock: "0.4em",
                alignItems: "flex-start",
                border: value === "individual" && "1px solid",
                boxShadow: "0px 0px 1px rgba(66, 90, 112, 0.4)",
                borderColor: value === "individual" && "primary.main",
                borderRadius: "8px",
                marginInline: "auto",
                "& span.MuiRadio-root": {
                  paddingBlock: "4px",
                },
                background: value === "individual" && "#F5F8FF",
              }}
              value="individual"
              checked={value === "individual"}
              control={<OtherRadio />}
              label={
                <Label
                  padding
                  head={"Individual Donee"}
                  body={
                    "Select this option if you are setting up a personal Donee account."
                  }
                />
              }
            />
          </RadioGroup>
        </FormControl> */}
        {/* <AlertDialog value={value} /> */}
        {/* <AlertDialog value={value} openDialog={openDialog} /> */}
        <RegisterModal show={show} handleShowChange={handleShowChange} closeModal={closeModal} />
      </Box>
    </>
  );
};
index.getLayout = function getLayout(page) {
  return <AuthLayout>{page}</AuthLayout>
};
export default index;
